
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3_1954)","fill":"#1D4ED8"}},[_c('path',{attrs:{"d":"M21.636 5.09H1.273C.573 5.09 0 5.665 0 6.365v20.363C0 27.427.573 28 1.273 28h20.363c.7 0 1.273-.573 1.273-1.273V6.364c0-.7-.573-1.273-1.273-1.273zm-5.09 17.82H6.364c-.7 0-1.273-.574-1.273-1.274 0-.7.573-1.272 1.273-1.272h10.181c.7 0 1.273.572 1.273 1.272 0 .7-.573 1.273-1.273 1.273zm0-5.092H6.364c-.7 0-1.273-.573-1.273-1.273s.573-1.272 1.273-1.272h10.181c.7 0 1.273.572 1.273 1.273 0 .7-.573 1.272-1.273 1.272zm0-5.09H6.364c-.7 0-1.273-.573-1.273-1.274 0-.7.573-1.272 1.273-1.272h10.181c.7 0 1.273.572 1.273 1.272 0 .7-.573 1.273-1.273 1.273z"}}),_c('path',{attrs:{"d":"M26.727 25.454h-5.09c-.7 0-1.273-.572-1.273-1.272V7.636h-14c-.7 0-1.273-.572-1.273-1.272V1.273C5.09.573 5.664 0 6.364 0h20.363C27.427 0 28 .573 28 1.273v22.909c0 .7-.573 1.273-1.273 1.273zM22.91 22.91h2.546V2.545H7.636v2.546h14c.7 0 1.273.573 1.273 1.273v16.545z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3_1954"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    